module.exports = __webpack_public_path__ + "img/zhiyaobankuai.8d8ce273.png";